module.exports = __webpack_public_path__ + "static/media/Title.2e267a3a.png";